import { render, staticRenderFns } from "./JsonShow.vue?vue&type=template&id=4e908bc8&scoped=true&"
import script from "./JsonShow.vue?vue&type=script&lang=js&"
export * from "./JsonShow.vue?vue&type=script&lang=js&"
import style0 from "./JsonShow.vue?vue&type=style&index=0&id=4e908bc8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e908bc8",
  null
  
)

export default component.exports